import type { Streamfield, WagtailSvg, WagtailImageRendition } from '@/types';
import Streamfields from '@streamfields/Streamfields';
import { BasePageProps, basePageWrap } from '@views/BasePage';
import React, { useEffect, useRef, useState } from 'react';
import Hero from '@components/Hero';
import Magazins from '@components/Magazin/Magazins';
import { MagazinType } from '@components/Magazin/Magazin';
import BannerImage from '@components/BannerImage';
import MailSvg from '@images/mail.svg';
import WhatsappSvg from '@images/whatsapp.svg';
import CopySvg from '@images/copy.svg';
import clsx from 'clsx';

type Props = {
  svg: WagtailSvg;
  title: string;
  subheader: string;
  subtitle: string;
  content: Streamfield[];
  banner_image: WagtailImageRendition | null;
  mobile_banner_image: WagtailImageRendition | null;
  magazin_orderable: MagazinType[];
} & BasePageProps;

function MagazinPage(props: Props) {
  const {
    content,
    svg,
    subtitle,
    banner_image,
    mobile_banner_image,
    subheader,
    title,
    blocksLoaderData,
  } = props;

  const [path, setPath] = useState('');

  const tooltipRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setPath(window.location.href);
    }
  }, []);

  return (
    <div className='flex-page'>
      <div
        className={clsx({
          'hero-content': banner_image,
        })}
      >
        {banner_image ? (
          <BannerImage image={banner_image} mobileImage={mobile_banner_image} />
        ) : (
          <div className='banner-image banner-image__small' />
        )}
        <Hero title={title} subtitle={subheader} text={subtitle} svg={svg} />
      </div>
      {content ? <Streamfields fields={content} blocksLoaderData={blocksLoaderData} /> : null}
      <div className='container'>
        <div className='article__share'>
          <a
            className='article__share-button'
            href={`https://wa.me/?text=${path}`}
            title='Per Whatsapp teilen'
          >
            <WhatsappSvg />
          </a>
          <a
            className='article__share-button'
            href={`mailto:?body=${path}`}
            title='Per Email teilen'
          >
            <MailSvg />
          </a>

          <button
            title='Link kopieren'
            className='article__share-button copy'
            onClick={() => {
              navigator.clipboard.writeText(path);
              tooltipRef.current?.classList.add('visible');
              setTimeout(() => {
                tooltipRef.current?.classList.remove('visible');
              }, 2000);
            }}
          >
            <CopySvg />
            <div className='article__share-copy-tooltip' ref={tooltipRef}>
              Link in der Zwischenablage gespeichert
            </div>
          </button>
        </div>
      </div>
      {props.magazin_orderable ? <Magazins magazins={props.magazin_orderable} /> : null}
    </div>
  );
}

export default basePageWrap<Props>(MagazinPage);
